var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChemical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_1601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 161
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#5D38E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_1601)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.3999,
    cy: 27.2313,
    r: 3.2,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.1999,
    cy: 116.831,
    r: 4.8,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.4,
    cy: 23.2313,
    r: 2.4,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.2,
    cy: 122.431,
    r: 4,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 110.431,
    r: 3.2,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6,
    cy: 12.0312,
    r: 2.4,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4894 43.9862V40.7862H67.2894H67.1731V36.8312H94.4268V40.7862H94.3105H91.1105V43.9862V76.2615V77.2174L91.6348 78.0167L122.32 124.793L122.344 124.829L122.368 124.865C124.475 127.893 122.309 132.039 118.62 132.039H42.9797C39.2914 132.039 37.1249 127.893 39.2314 124.865L39.2564 124.829L39.2804 124.793L69.965 78.0167L70.4894 77.2174V76.2615V43.9862Z",
    stroke: "#5D38E5",
    strokeWidth: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5347 99.5735H104.065",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChemical);
export default __webpack_public_path__ + "static/media/icon_chemical.97355b93a087d1f8d1cb4de33aa632c9.svg";
export { ForwardRef as ReactComponent };